
// src/reducers/outlook-api-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'
import moment from 'moment'

import { 
  FETCH_OUTLOOK_CALENDAR_EVENTS,
  FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED,
  FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED,
  FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED,
  FETCH_OUTLOOK_CALENDARS,
  FETCH_OUTLOOK_CALENDARS_REQUESTED,
  FETCH_OUTLOOK_CALENDARS_COMPLETED,
  FETCH_OUTLOOK_CALENDARS_FAILED,
  CLEAR_OUTLOOK_CALENDAR_EVENTS,
  CLEAR_OUTLOOK_CALENDARS,
} from '../actions/outlook-calendar'
import actions from '../actions'

const initialState = {
  isFetching: false,
  isFetchFailed: false,
  isCalendarFatching: false,
  isCalendarFatchFailed: false,
  calendars: undefined,
  events: undefined,
  selectDate: undefined,
}

export default function outlookApiReducer(state = initialState, action = {}) {
  switch(action.type) {

  case FETCH_OUTLOOK_CALENDARS_REQUESTED:
    return Object.assign({}, state, {
      isCalendarFetching: true,
      isCalendarFetchFailed: false,
    })

  case FETCH_OUTLOOK_CALENDARS_FAILED:
    return Object.assign({}, state, {
      isCalendarFetching: false,
      isCalendarFetchFailed: true,
    })

  case FETCH_OUTLOOK_CALENDARS_COMPLETED:
    return Object.assign({}, state, {
      isCalendarFetching: false,
      isCalendarFetchFailed: false,
      calendars: action.results,
    })

  case FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFetchFailed: false,
    })

  case FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: true,
    })

  case CLEAR_OUTLOOK_CALENDARS:
    return {
      calendars: undefined
    }

  case FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED:
    //1日の予定を取得する
    const resultsData = action.results && action.results.filter((result) => {
      return result.startTime && result.endTime && moment(result.startTime).format('YYYY-MM-DD') == moment(result.endTime).format('YYYY-MM-DD')
    })
    //日跨ぎの予定または終日の予定をfilterする
    const straddlingTheDayData = action.results && action.results.filter((result) => {
      return result.startTime && result.endTime && moment(result.startTime).format('YYYY-MM-DD') != moment(result.endTime).format('YYYY-MM-DD') || result.date && result.endDate
    })

    //straddlingTheDayDataで取得した値が配列の先頭に来るようにする
    const calendarData = resultsData && straddlingTheDayData && straddlingTheDayData.length > 0 ? straddlingTheDayData.concat(resultsData) : null

    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      events: Object.assign({}, state.events, {
        [action.calendar]: Object.assign({}, state.events ? state.events[action.calendar] : {}, calendarData ? { [moment(action.selectDate).format('YYYY-MM-DD')]: calendarData } : { [moment(action.selectDate).format('YYYY-MM-DD')]: action.results })
      })
    })

  case CLEAR_OUTLOOK_CALENDAR_EVENTS:
    return Object.assign({}, state, {
      events: undefined,
      selectDate: undefined,
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/outlook-api-reducer.js